// NOTE: AUTO GENERATED FILE! Do not modify directly!

export enum BreakpointsEnum {
  'small' = 'small',
  'medium' = 'medium',
  'tabletportrait' = 'tabletportrait',
  'large' = 'large',
  'xlarge' = 'xlarge',
  'xxlarge' = 'xxlarge'
}
